import React from "react";
import { Link } from 'react-router-dom'
import sliderInner from '../assets/images/sliderInner.jpg';
import { GrDocumentPdf } from "react-icons/gr";

function WhatsnewDetails() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
      </section>
      <section className="sevenScopeSec reduceWasteSec aboutUsSec">
        {/* <img className="slider__shape-13" src={leafIcn} alt="" /> */}
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>What's  <span className="hdngBrkr">New</span> </h2>
          <div className="sevenScopeBox">
            <p>Internship Programme of the Ministry Environment, Forest and Climate Change Commencement of Summer Session 2024 and selection of Divisional Heads for the purpose of Internship Scheme</p>
            <p className="lstDatetxt"><strong>Last date: </strong>13-06-2024 at 23.59 Hrs</p>
            <p><Link to="" className="pdfIcn"><GrDocumentPdf /> </Link></p>
          </div>
        </div>
      </section>
    </>
  );
}

export default WhatsnewDetails;
